import { Route } from "react-router-dom";
import Profile from "../component/profile/Profile";
import ChangePasswordPage from "../component/profile/ChangePasswordPage";
import { Routes as GlobalRoutes } from "../constants/RouteConstants";
import AddressSelect from "../component/resuest-quote/AddressSelect";
import RequestQuote2 from "../component/resuest-quote/IncorrectExcel";
import RequestQuote from "../component/resuest-quote/RequestQuote";
import MyQuotation from "../component/myquotation/MyQuotation";
import MyquotationView from "../component/myquotation/MyquotationView";
import QuotationCheckout from "../component/myquotation/QuotationCheckout";
import QuotationPdfPreview from "../component/myquotation/QuotationPdfPreview";
import Order from "../component/myorder/Order";
import OrderDetail from "../component/myorder/OrderDetail";
import OrderCheckout from "../component/myorder/OrderCheckout";
import OrderPdfPreview from "../component/myorder/OrderPdfPreview";
import ExcelSelect from "../component/resuest-quote/ExcelSelect";
import Notification from "../component/notification/Notification";
import QutationHistory from "../component/myquotation/QutationHistory";
import AddressList from "../component/address/AddressList";
import NewAddressPage from "../component/address/NewAddressPage";
import UpdateAddress from "../Modal/UpdateAddress";
import Category from "../component/category/Category";
import UpdateCateory from "../component/category/UpdateCateory";
import Draft from "../component/draft/Draft";
const routes = [
  {
    path: GlobalRoutes.Profile,
    element: <Profile />,
  },
  {
    path: GlobalRoutes.ChangePassword,
    element: <ChangePasswordPage />,
  },
  {
    path: GlobalRoutes.SelectAddress,
    element: <AddressSelect />,
  },
  {
    path: GlobalRoutes.SelectExcel,
    element: <ExcelSelect />,
  },
  {
    path: GlobalRoutes.RequestQuoteCreateSecond,
    element: <RequestQuote2 />,
  },
  {
    path: GlobalRoutes.RequestQuoteCreate,
    element: <RequestQuote />,
  },
  {
    path: GlobalRoutes.MyQuote,
    element: <MyQuotation />,
  },
  {
    path: GlobalRoutes.Drafts,
    element: <Draft />,
  },
  {
    path: GlobalRoutes.Viewquote,
    element: <MyquotationView />,
  },
  {
    path: GlobalRoutes.QuotationCheckout,
    element: <QuotationCheckout />,
  },
  {
    path: GlobalRoutes.QuotationPdfPreview,
    element: <QuotationPdfPreview />,
  },
  {
    path: GlobalRoutes.Order,
    element: <Order />,
  },
  {
    path: GlobalRoutes.OrderDetail,
    element: <OrderDetail />,
  },
  {
    path: GlobalRoutes.OrderCheckout,
    element: <OrderCheckout />,
  },
  {
    path: GlobalRoutes.OrderPdfPreview,
    element: <OrderPdfPreview />,
  },
  {
    path: GlobalRoutes.Notification,
    element: <Notification />,
  },
  {
    path: GlobalRoutes.QutationHistory,
    element: <QutationHistory />,
  },
  {
    path: GlobalRoutes.AddressList,
    element: <AddressList />,
  },
  {
    path: GlobalRoutes.AddressCreate,
    element: <NewAddressPage />,
  },
  {
    path: GlobalRoutes.AddressEdit,
    element: <UpdateAddress />,
  },
  {
    path: GlobalRoutes.CategoryList,
    element: <Category />,
  },
  {
    path: GlobalRoutes.UpdatecategoryList,
    element: <UpdateCateory />,
  },
];

export const routeComponents = routes.map((route, index) => (
  <Route key={index} path={route.path} element={route.element} />
));